import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-space-50"
}
const _hoisted_2 = { class: "container-lil" }
const _hoisted_3 = { class: "secondary-font mb-6" }
const _hoisted_4 = {
  key: 0,
  style: {"height":"200px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_5 = { class: "s10_mobile" }
const _hoisted_6 = { class: "s5" }
const _hoisted_7 = { href: "" }
const _hoisted_8 = { class: "img-area mb-0 px-3 py-2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "s14" }
const _hoisted_11 = { href: "" }
const _hoisted_12 = { class: "title secondary-font text-grey-600 mb-3" }
const _hoisted_13 = { class: "price secondary-font mb-3" }
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = { style: {"flex":"1"} }
const _hoisted_16 = {
  key: 0,
  class: "font-semibold secondary-font text-medium text-grey-600 ml-5"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "s9_mobile" }

import { useMarketCartStore } from '@/stores/cart.store';
import { formatAmount } from '@/utils/formatters';
import { inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import SpinnerQuantityInput from './components/SpinnerQuantityInput.vue';
import MarketCartInfos from './components/MarketCartInfos.vue';
import { showAlert } from '@/utils/swal';
import ConfirmationModal from '@/components/ConfirmationModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PanierView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const cart = useMarketCartStore();
const { items } = storeToRefs(cart);
const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
const loadingRemoveFromCart = ref(false);
const errorRemoveFromCart = ref('');

onMounted(() => {
    layout.value = router.currentRoute.value.meta.layout as string || 'none';
});

function onItemQuantityChanged(item_id: number, new_quantity: number) {
    cart.setQuantity(item_id, new_quantity);
}

async function onRemoveItemFromCart(item_id: number) {
    const confirm = await confirmationModalRef.value?.open("Panier", "Voulez-vous vraiment retirer cet article du panier ?");
    if (confirm) {
        try {
            loadingRemoveFromCart.value = true;
            cart.removeFromCart(item_id);
        } catch(error: any) {
            errorRemoveFromCart.value = error.message || 'Une erreur est survenue lors de la requete au serveur. Veuillez réessayer.';
            await showAlert.error(errorRemoveFromCart.value);
        } finally {
            loadingRemoveFromCart.value = false;
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (layout.value == 'none')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, "Panier / " + _toDisplayString(_unref(cart).getTotalItems) + " Articles", 1),
      (_unref(items).length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h4", { class: "secondary-font" }, "Aucun article ajouté dans le panier", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_unref(items).length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex-center mb-6",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + item.image,
                          width: "100%"
                        }, null, 8, _hoisted_9)
                      ])
                    ])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "s1" }, " ", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("a", _hoisted_11, [
                      _createElementVNode("h6", _hoisted_12, _toDisplayString(item.nom), 1)
                    ]),
                    _createElementVNode("h5", _hoisted_13, [
                      _createTextVNode(_toDisplayString(item.quantite + ' x ' + _unref(formatAmount)(item.montant_apres_remises)) + " ", 1),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "secondary-font" }, "F", -1))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(SpinnerQuantityInput, {
                        "model-value": item.quantite,
                        "min-value": 1,
                        "onUpdate:modelValue": ($event: any) => (onItemQuantityChanged(item.id, $event))
                      }, null, 8, ["model-value", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        (item.nb_echeance > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Payer en " + _toDisplayString(item.nb_echeance) + " fois", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        class: "btn sm light",
                        title: "Retirer du panier",
                        onClick: ($event: any) => (onRemoveItemFromCart(item.id))
                      }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-code-delete.svg",
                          width: "16px"
                        }, null, -1)
                      ]))], 8, _hoisted_17)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(MarketCartInfos, { layout: layout.value }, null, 8, ["layout"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ], 64))
}
}

})